(function () {
'use strict';

angular
    .module('surveyCampaignControllers')
    .directive('campaignVisualComponentCard', directive);

directive.$inject = [];

function directive() {
    return {
        scope: {
            visualComponent: '=',
            componentIdx: '=',
            isOrdering: '=',
            isLast: '=',
            layoutRatio: '=?',
            moveUp: '&',
            moveDown: '&',
            readOnly: '=',
            toRemoveVisualComponent: '&'
        },
        restrict: 'AE',
        templateUrl: require('./campaignVisualComponentCard.tpl.html'),
        controller: ['$scope', function ($scope) {
            $scope.showOrHideActions = function ($event) {
                if ($scope.readOnly || $scope.isOrdering) return;
                $scope.view.displayActions = !$scope.view.displayActions;
                $event.stopPropagation();
            };

            $scope.isPageBreak = function () {
                return $scope.visualComponent.VisualComponentTypeID === 1;
            };

            $scope.removeVisualComponent = function ($event) {
                $scope.toRemoveVisualComponent();
                $event.stopPropagation;
            };
        }],
        link: function (scope, element, attrs) {
            scope.layoutRatio = scope.layoutRatio ? scope.layoutRatio : {
                column: 'col-sm-12'
            };

            // Display or not actions
            scope.view                          = {};
            scope.view.displayActions           = false;
        }
    };
}
})();